import { axiosFactory } from './axiosFactory'

export const axiosCustomer = axiosFactory.getAxios('customer')
